(ns frontend.view.modals.nylas-connect.view
  (:require
   [common.localization :as loc]
   [frontend.state.current-session :as session]
   [frontend.view.modals.nylas-connect.event :as event]
   [frontend.view.modals.nylas-connect.sub :as sub]
   [re-frame.core :as rf]
   [reagent.core]
   [ui.components.modal.view :as modal]
   [ui.components.radio-group.view :as radio-group]
   [ui.components.radix-ui.tooltip.view :as tooltip]
   [ui.editors.labelled-input.view :as labelled-input]))

(defonce modal-key :nylas-connect-modal)

(defn microsoft-button
  [provider-selected!]
  [:button
   {:type     "button"
    :on-click (fn [_]
                (provider-selected! :nylas.provider/microsoft))
    :class    "flex items-center h-[41px] px-3 w-fit
          bg-white border border-[#8C8C8C] rounded
          text-[#5E5E5E] text-[15px] font-semibold
          font-sans whitespace-nowrap select-none
          transition duration-200 hover:shadow-md focus:outline-none"}

   ;; Icon (assumes 20×20 SVG)
   [:div {:class "w-5 h-5 mr-3 flex-shrink-0"}
    ;; Insert your Microsoft SVG here:
    [:svg {:xmlns   "http://www.w3.org/2000/svg"
           :viewBox "0 0 24 24"
           :class   "w-full h-full"}
     ;; Example Microsoft logo:
     [:svg {:xmlns   "http://www.w3.org/2000/svg"
            :width   "21"
            :height  "21"
            :viewBox "0 0 21 21"}
      [:title "MS-SymbolLockup"]
      [:rect {:x "1" :y "1" :width "9" :height "9" :fill "#f25022"}]
      [:rect {:x "1" :y "11" :width "9" :height "9" :fill "#00a4ef"}]
      [:rect {:x "11" :y "1" :width "9" :height "9" :fill "#7fba00"}]
      [:rect {:x "11" :y "11" :width "9" :height "9" :fill "#ffb900"}]]]]
   ;; Button label
   [:span "Sign in with Microsoft"]])

(defn google-button
  [provider-selected!]
  [:button
   {:type     "button"
    :on-click (fn [_]
                (provider-selected! :nylas.provider/google))
    :class    "relative inline-flex items-center justify-between
           mb-0
          w-auto max-w-[400px] min-w-min h-10 px-3
          text-[#1f1f1f] text-sm text-center font-sans
          border border-[#747775] rounded-[20px]
          bg-white select-none overflow-hidden
          align-middle whitespace-nowrap
          transition-[background-color,border-color,box-shadow] duration-200
          focus:outline-none hover:shadow-md disabled:cursor-default
          disabled:bg-white/40 disabled:border-[#1f1f1f1f]"}
   [:div
    {:class "absolute inset-0 bg-[#303030] opacity-0 transition-opacity duration-200 pointer-events-none"}]

   [:div
    {:class "relative flex flex-row flex-nowrap items-center justify-between w-full h-full"}

    ;; Icon
    [:div
     {:class "w-5 h-5 min-w-[20px] mr-3 disabled:opacity-40"}
     [:svg {:xmlns       "http://www.w3.org/2000/svg"
            :xmlns:xlink "http://www.w3.org/1999/xlink"
            :viewBox     "0 0 48 48"
            :style       {:display "block"}}
      [:path {:fill "#EA4335"
              :d    "M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"}]
      [:path {:fill "#4285F4"
              :d    "M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"}]
      [:path {:fill "#FBBC05"
              :d    "M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"}]
      [:path {:fill "#34A853"
              :d    "M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"}]
      [:path {:fill "none" :d "M0 0h48v48H0z"}]]]

    ;; Button content
    [:span
     {:class "grow font-medium overflow-hidden text-ellipsis whitespace-nowrap disabled:opacity-40"}
     "Sign up with Google"]

    ;; Visually hidden fallback label
    [:span {:class "sr-only"} "Sign up with Google"]]])

(defn privacy-setting
  []
  (let [keep-private? @(rf/subscribe [::sub/keep-private?])]
    [:div
     {:class "flex flex-col gap-2"}
     [:label
      {:class "text-bold"}
      (loc/tr :nylas-connect/connect-privacy-settings)]
     [radio-group/radio-group-v2
      {:checked   keep-private?
       :on-change (fn [checked?]
                    (rf/dispatch [::event/toggle-private? checked?]))}
      [{:value   false
        :content (loc/tr :nylas-connect/conversations-share)}
       {:value   true
        :content (loc/tr :nylas-connect/conversations-private)}]]]))

(defn sync-contacts-setting
  []
  (let [sync-contacts? @(rf/subscribe [::sub/sync-contacts?])]
    [:div
     {:class "flex flex-col gap-2"}
     [:label
      {:class "text-bold flex flex-row gap-1"}
      (loc/tr :nylas-connect/connect-sync-contacts-settings)
      [tooltip/view
       [:i.fal.fa-info-circle]
       (loc/tr :nylas-connect/what-is-sharing-info)]]
     [radio-group/radio-group-v2
      {:checked   sync-contacts?
       :on-change (fn [checked?]
                    (rf/dispatch [::event/toggle-sync-contacts? checked?]))}
      [{:value   false
        :content (loc/tr :nylas-connect/do-not-sync-contacts)}
       {:value   true
        :content (loc/tr :nylas-connect/link-with-email-address)}]]]))

(defn email-hint
  []
  (let [email @(rf/subscribe [::sub/email-hint])]
    [labelled-input/view
     {:label     (loc/tr :nylas-connect/link-with-email-address)
      :data-type :data.type/email
      :dom-id    "nylas-connect-modal-email"
      :value     (or email (:account/email @session/account))
      :on-change (fn [txt-value]
                   (rf/dispatch [::event/set-email-hint txt-value]))}]))

(defn view
  [{:keys [shown? close-modal! props state class-name topmost?]}]
  (let [{:keys [on-confirm!]} props
        [keep-private? sync-contacts?] (if (->> @session/account
                                                :account/default-nylas-privacy
                                                (= :privacy-status/private))
                                         [true false]
                                         [false true])
        account-email (:account/email @session/account)]

    (rf/dispatch [::event/init keep-private? sync-contacts? account-email])

    (fn [{:keys [shown? close-modal! props state class-name topmost?]}]
      (let [sync-contacts? @(rf/subscribe [::sub/sync-contacts?])
            email-hint-txt @(rf/subscribe [::sub/email-hint])
            keep-private? @(rf/subscribe [::sub/keep-private?])
            provider-selected! (fn [provider]
                                 (on-confirm! {:close-modal!          close-modal!
                                               :provider              provider
                                               :sync-contacts?        (boolean sync-contacts?)
                                               :email                 (or email-hint-txt "")
                                               :default-nylas-privacy (if keep-private?
                                                                        :privacy-status/private
                                                                        :privacy-status/public)}))]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :close-button? true}
         (loc/tr :nylas-connect/modal-title)
         [:<>
          [:div
           {:class "flex flex-col gap-4"}
           [:p
            {:class "font-bold"}
            (loc/tr :nylas-connect/connect-your-email-info)]
           [:label (loc/tr :nylas-connect/connect-your-email-info-label)]
           [privacy-setting]
           [sync-contacts-setting]
           [email-hint]]]
         [:<>
          [modal/left-cancel-only close-modal! "nylas-connect-cancel-button"]
          [:div
           {:class "flex gap-2 justify-end items-center ml-auto"}
           [google-button provider-selected!]
           [microsoft-button provider-selected!]]]]))))
